// Rate limiter local (cliente) por email. Sincroniza en localStorage con TTL.
// Estructura { count, last, cooldownUntil }

const KEY = 'auth.failmap.v1';

function loadMap() {
  try {
    const raw = localStorage.getItem(KEY);
    const obj = raw ? JSON.parse(raw) : {};
    // limpieza simple: borra entradas con cooldown vencido y last > 24h
    const now = Date.now();
    for (const k of Object.keys(obj)) {
      const it = obj[k];
      if ((it.cooldownUntil && it.cooldownUntil < now) && (it.last && now - it.last > 24*3600e3)) {
        delete obj[k];
      }
    }
    return obj;
  } catch { return {}; }
}

function saveMap(map) {
  try { localStorage.setItem(KEY, JSON.stringify(map)); } catch {}
}

export function getFailInfo(email) {
  const map = loadMap();
  const key = (email||'').trim().toLowerCase();
  return map[key] || { count: 0, last: 0, cooldownUntil: 0 };
}

export function registerFail(email) {
  const map = loadMap();
  const key = (email||'').trim().toLowerCase();
  const prev = map[key] || { count: 0, last: 0, cooldownUntil: 0 };
  const count = (prev.count||0) + 1;
  const now = Date.now();
  // Backoff ligero si >=3; cooldown fuerte si >=10
  let cooldownUntil = prev.cooldownUntil || 0;
  if (count >= 10) {
    cooldownUntil = now + 15 * 60 * 1000; // 15 minutos
  }
  map[key] = { count, last: now, cooldownUntil };
  saveMap(map);
  return map[key];
}

export function resetFails(email) {
  const map = loadMap();
  const key = (email||'').trim().toLowerCase();
  if (map[key]) {
    delete map[key];
    saveMap(map);
  }
}

export function computeBackoffMs(info) {
  if (!info) return 0;
  if (info.count < 3) return 0;
  // Backoff exponencial suave desde 1s hasta 5s
  const n = Math.min(5, info.count - 2);
  return n * 1000;
}
